
import { GraficosProps } from '../../../containers/pages/Dashboard';
import {
  BAJAS_DASHBOARD_REQUEST,
  BAJAS_DASHBOARD_SUCCESS,
  BAJAS_DASHBOARD_FAIL
} from '../../actions/Dashboard/types';

// Define el tipo para el estado inicial
interface DatosInventarioState {
  bajasDashboard: GraficosProps[];
}
// Estado inicial tipado
const initialState: DatosInventarioState = {
  bajasDashboard: [],
};

// Reducer con tipos definidos
const bajasReducers = (state = initialState, action: any) => {
  switch (action.type) {
    case BAJAS_DASHBOARD_REQUEST:
      return { ...state, loading: true };
    case BAJAS_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        bajasDashboard: action.payload,
      };
    case BAJAS_DASHBOARD_FAIL:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};



export default bajasReducers;
